/* from https://www.esrl.noaa.gov/gmd/grad/solcalc/main.js */ function $10779855fb2df467$var$calcTimeJulianCent(jd) {
    var T = (jd - 2451545.0) / 36525.0;
    return T;
}
function $10779855fb2df467$var$calcJDFromJulianCent(t) {
    var JD = t * 36525.0 + 2451545.0;
    return JD;
}
function $10779855fb2df467$var$isLeapYear(yr) {
    return yr % 4 == 0 && yr % 100 != 0 || yr % 400 == 0;
}
function $10779855fb2df467$var$calcDateFromJD(jd) {
    var z = Math.floor(jd + 0.5);
    var f = jd + 0.5 - z;
    if (z < 2299161) var A = z;
    else {
        var alpha = Math.floor((z - 1867216.25) / 36524.25);
        var A = z + 1 + alpha - Math.floor(alpha / 4);
    }
    var B = A + 1524;
    var C = Math.floor((B - 122.1) / 365.25);
    var D = Math.floor(365.25 * C);
    var E = Math.floor((B - D) / 30.6001);
    var day = B - D - Math.floor(30.6001 * E) + f;
    var month = E < 14 ? E - 1 : E - 13;
    var year = month > 2 ? C - 4716 : C - 4715;
    return {
        "year": year,
        "month": month,
        "day": day
    };
}
function $10779855fb2df467$var$calcDoyFromJD(jd) {
    var date = $10779855fb2df467$var$calcDateFromJD(jd);
    var k = $10779855fb2df467$var$isLeapYear(date.year) ? 1 : 2;
    var doy = Math.floor(275 * date.month / 9) - k * Math.floor((date.month + 9) / 12) + date.day - 30;
    return doy;
}
function $10779855fb2df467$var$radToDeg(angleRad) {
    return 180.0 * angleRad / Math.PI;
}
function $10779855fb2df467$var$degToRad(angleDeg) {
    return Math.PI * angleDeg / 180.0;
}
function $10779855fb2df467$var$calcGeomMeanLongSun(t) {
    var L0 = 280.46646 + t * (36000.76983 + t * 0.0003032);
    while(L0 > 360.0)L0 -= 360.0;
    while(L0 < 0.0)L0 += 360.0;
    return L0 // in degrees
    ;
}
function $10779855fb2df467$var$calcGeomMeanAnomalySun(t) {
    var M = 357.52911 + t * (35999.05029 - 0.0001537 * t);
    return M; // in degrees
}
function $10779855fb2df467$var$calcEccentricityEarthOrbit(t) {
    var e = 0.016708634 - t * (0.000042037 + 0.0000001267 * t);
    return e; // unitless
}
function $10779855fb2df467$var$calcSunEqOfCenter(t) {
    var m = $10779855fb2df467$var$calcGeomMeanAnomalySun(t);
    var mrad = $10779855fb2df467$var$degToRad(m);
    var sinm = Math.sin(mrad);
    var sin2m = Math.sin(mrad + mrad);
    var sin3m = Math.sin(mrad + mrad + mrad);
    var C = sinm * (1.914602 - t * (0.004817 + 0.000014 * t)) + sin2m * (0.019993 - 0.000101 * t) + sin3m * 0.000289;
    return C; // in degrees
}
function $10779855fb2df467$var$calcSunTrueLong(t) {
    var l0 = $10779855fb2df467$var$calcGeomMeanLongSun(t);
    var c = $10779855fb2df467$var$calcSunEqOfCenter(t);
    var O = l0 + c;
    return O; // in degrees
}
function $10779855fb2df467$var$calcSunTrueAnomaly(t) {
    var m = $10779855fb2df467$var$calcGeomMeanAnomalySun(t);
    var c = $10779855fb2df467$var$calcSunEqOfCenter(t);
    var v = m + c;
    return v; // in degrees
}
function $10779855fb2df467$var$calcSunRadVector(t) {
    var v = $10779855fb2df467$var$calcSunTrueAnomaly(t);
    var e = $10779855fb2df467$var$calcEccentricityEarthOrbit(t);
    var R = 1.000001018 * (1 - e * e) / (1 + e * Math.cos($10779855fb2df467$var$degToRad(v)));
    return R; // in AUs
}
function $10779855fb2df467$var$calcSunApparentLong(t) {
    var o = $10779855fb2df467$var$calcSunTrueLong(t);
    var omega = 125.04 - 1934.136 * t;
    var lambda = o - 0.00569 - 0.00478 * Math.sin($10779855fb2df467$var$degToRad(omega));
    return lambda; // in degrees
}
function $10779855fb2df467$var$calcMeanObliquityOfEcliptic(t) {
    var seconds = 21.448 - t * (46.8150 + t * (0.00059 - t * 0.001813));
    var e0 = 23.0 + (26.0 + seconds / 60.0) / 60.0;
    return e0; // in degrees
}
function $10779855fb2df467$var$calcObliquityCorrection(t) {
    var e0 = $10779855fb2df467$var$calcMeanObliquityOfEcliptic(t);
    var omega = 125.04 - 1934.136 * t;
    var e = e0 + 0.00256 * Math.cos($10779855fb2df467$var$degToRad(omega));
    return e; // in degrees
}
function $10779855fb2df467$var$calcSunRtAscension(t) {
    var e = $10779855fb2df467$var$calcObliquityCorrection(t);
    var lambda = $10779855fb2df467$var$calcSunApparentLong(t);
    var tananum = Math.cos($10779855fb2df467$var$degToRad(e)) * Math.sin($10779855fb2df467$var$degToRad(lambda));
    var tanadenom = Math.cos($10779855fb2df467$var$degToRad(lambda));
    var alpha = $10779855fb2df467$var$radToDeg(Math.atan2(tananum, tanadenom));
    return alpha; // in degrees
}
function $10779855fb2df467$var$calcSunDeclination(t) {
    var e = $10779855fb2df467$var$calcObliquityCorrection(t);
    var lambda = $10779855fb2df467$var$calcSunApparentLong(t);
    var sint = Math.sin($10779855fb2df467$var$degToRad(e)) * Math.sin($10779855fb2df467$var$degToRad(lambda));
    var theta = $10779855fb2df467$var$radToDeg(Math.asin(sint));
    return theta; // in degrees
}
function $10779855fb2df467$var$calcEquationOfTime(t) {
    var epsilon = $10779855fb2df467$var$calcObliquityCorrection(t);
    var l0 = $10779855fb2df467$var$calcGeomMeanLongSun(t);
    var e = $10779855fb2df467$var$calcEccentricityEarthOrbit(t);
    var m = $10779855fb2df467$var$calcGeomMeanAnomalySun(t);
    var y = Math.tan($10779855fb2df467$var$degToRad(epsilon) / 2.0);
    y *= y;
    var sin2l0 = Math.sin(2.0 * $10779855fb2df467$var$degToRad(l0));
    var sinm = Math.sin($10779855fb2df467$var$degToRad(m));
    var cos2l0 = Math.cos(2.0 * $10779855fb2df467$var$degToRad(l0));
    var sin4l0 = Math.sin(4.0 * $10779855fb2df467$var$degToRad(l0));
    var sin2m = Math.sin(2.0 * $10779855fb2df467$var$degToRad(m));
    var Etime = y * sin2l0 - 2.0 * e * sinm + 4.0 * e * y * sinm * cos2l0 - 0.5 * y * y * sin4l0 - 1.25 * e * e * sin2m;
    return $10779855fb2df467$var$radToDeg(Etime) * 4.0; // in minutes of time
}
function $10779855fb2df467$var$calcHourAngleSunrise(lat, solarDec) {
    var latRad = $10779855fb2df467$var$degToRad(lat);
    var sdRad = $10779855fb2df467$var$degToRad(solarDec);
    var HAarg = Math.cos($10779855fb2df467$var$degToRad(90.833)) / (Math.cos(latRad) * Math.cos(sdRad)) - Math.tan(latRad) * Math.tan(sdRad);
    var HA = Math.acos(HAarg);
    return HA; // in radians (for sunset, use -HA)
}
function $10779855fb2df467$var$isNumber(inputVal) {
    var oneDecimal = false;
    var inputStr = "" + inputVal;
    for(var i = 0; i < inputStr.length; i++){
        var oneChar = inputStr.charAt(i);
        if (i == 0 && (oneChar == "-" || oneChar == "+")) continue;
        if (oneChar == "." && !oneDecimal) {
            oneDecimal = true;
            continue;
        }
        if (oneChar < "0" || oneChar > "9") return false;
    }
    return true;
}
function $10779855fb2df467$export$fb750f7620defd41(year, month, day) {
    if (month <= 2) {
        year -= 1;
        month += 12;
    }
    var A = Math.floor(year / 100);
    var B = 2 - A + Math.floor(A / 4);
    var JD = Math.floor(365.25 * (year + 4716)) + Math.floor(30.6001 * (month + 1)) + day + B - 1524.5;
    return JD;
}
function $10779855fb2df467$var$calcRefraction(elev) {
    if (elev > 85.0) var correction = 0.0;
    else {
        var te = Math.tan($10779855fb2df467$var$degToRad(elev));
        if (elev > 5.0) var correction = 58.1 / te - 0.07 / (te * te * te) + 0.000086 / (te * te * te * te * te);
        else if (elev > -0.575) var correction = 1735.0 + elev * (-518.2 + elev * (103.4 + elev * (-12.79 + elev * 0.711)));
        else var correction = -20.774 / te;
        correction = correction / 3600.0;
    }
    return correction;
}
function $10779855fb2df467$var$calcAzEl(T, localtime, latitude, longitude, zone) {
    var eqTime = $10779855fb2df467$var$calcEquationOfTime(T);
    var theta = $10779855fb2df467$var$calcSunDeclination(T);
    var solarTimeFix = eqTime + 4.0 * longitude - 60.0 * zone;
    var earthRadVec = $10779855fb2df467$var$calcSunRadVector(T);
    var trueSolarTime = localtime + solarTimeFix;
    while(trueSolarTime > 1440)trueSolarTime -= 1440;
    var hourAngle = trueSolarTime / 4.0 - 180.0;
    if (hourAngle < -180) hourAngle += 360.0;
    var haRad = $10779855fb2df467$var$degToRad(hourAngle);
    var csz = Math.sin($10779855fb2df467$var$degToRad(latitude)) * Math.sin($10779855fb2df467$var$degToRad(theta)) + Math.cos($10779855fb2df467$var$degToRad(latitude)) * Math.cos($10779855fb2df467$var$degToRad(theta)) * Math.cos(haRad);
    if (csz > 1.0) csz = 1.0;
    else if (csz < -1) csz = -1;
    var zenith = $10779855fb2df467$var$radToDeg(Math.acos(csz));
    var azDenom = Math.cos($10779855fb2df467$var$degToRad(latitude)) * Math.sin($10779855fb2df467$var$degToRad(zenith));
    if (Math.abs(azDenom) > 0.001) {
        var azRad = (Math.sin($10779855fb2df467$var$degToRad(latitude)) * Math.cos($10779855fb2df467$var$degToRad(zenith)) - Math.sin($10779855fb2df467$var$degToRad(theta))) / azDenom;
        if (Math.abs(azRad) > 1.0) {
            if (azRad < 0) azRad = -1;
            else azRad = 1.0;
        }
        var azimuth = 180.0 - $10779855fb2df467$var$radToDeg(Math.acos(azRad));
        if (hourAngle > 0.0) azimuth = -azimuth;
    } else if (latitude > 0.0) var azimuth = 180.0;
    else var azimuth = 0.0;
    if (azimuth < 0.0) azimuth += 360.0;
    var exoatmElevation = 90.0 - zenith;
    // Atmospheric Refraction correction
    var refractionCorrection = $10779855fb2df467$var$calcRefraction(exoatmElevation);
    var solarZen = zenith - refractionCorrection;
    var elevation = 90.0 - solarZen;
    return {
        "azimuth": azimuth,
        "elevation": elevation
    };
}
function $10779855fb2df467$var$calcSolNoon(jd, longitude, timezone) {
    var tnoon = $10779855fb2df467$var$calcTimeJulianCent(jd - longitude / 360.0);
    var eqTime = $10779855fb2df467$var$calcEquationOfTime(tnoon);
    var solNoonOffset = 720.0 - longitude * 4 - eqTime // in minutes
    ;
    var newt = $10779855fb2df467$var$calcTimeJulianCent(jd + solNoonOffset / 1440.0);
    eqTime = $10779855fb2df467$var$calcEquationOfTime(newt);
    var solNoonLocal = 720 - longitude * 4 - eqTime + timezone * 60.0 // in minutes
    ;
    while(solNoonLocal < 0.0)solNoonLocal += 1440.0;
    while(solNoonLocal >= 1440.0)solNoonLocal -= 1440.0;
    return solNoonLocal;
}
function $10779855fb2df467$var$calcSunriseSetUTC(rise, JD, latitude, longitude) {
    var t = $10779855fb2df467$var$calcTimeJulianCent(JD);
    var eqTime = $10779855fb2df467$var$calcEquationOfTime(t);
    var solarDec = $10779855fb2df467$var$calcSunDeclination(t);
    var hourAngle = $10779855fb2df467$var$calcHourAngleSunrise(latitude, solarDec);
    if (!rise) hourAngle = -hourAngle;
    var delta = longitude + $10779855fb2df467$var$radToDeg(hourAngle);
    var timeUTC = 720 - 4.0 * delta - eqTime; // in minutes
    return timeUTC;
}
function $10779855fb2df467$export$a312825e91363456(rise, JD, latitude, longitude, timezone) {
    if (typeof latitude !== 'number') throw new Error('latitude must be a number');
    if (typeof longitude !== 'number') throw new Error('longitude must be a number');
    var timeUTC = $10779855fb2df467$var$calcSunriseSetUTC(rise, JD, latitude, longitude);
    var newTimeUTC = $10779855fb2df467$var$calcSunriseSetUTC(rise, JD + timeUTC / 1440.0, latitude, longitude);
    if ($10779855fb2df467$var$isNumber(newTimeUTC)) {
        var timeLocal = newTimeUTC + timezone * 60.0;
        var riseT = $10779855fb2df467$var$calcTimeJulianCent(JD + newTimeUTC / 1440.0);
        var riseAzEl = $10779855fb2df467$var$calcAzEl(riseT, timeLocal, latitude, longitude, timezone);
        var azimuth = riseAzEl.azimuth;
        var jday = JD;
        if (timeLocal < 0.0 || timeLocal >= 1440.0) {
            var increment = timeLocal < 0 ? 1 : -1;
            while(timeLocal < 0.0 || timeLocal >= 1440.0){
                timeLocal += increment * 1440.0;
                jday -= increment;
            }
        }
    } else {
        var azimuth = -1;
        var timeLocal = 0.0;
        var doy = $10779855fb2df467$var$calcDoyFromJD(JD);
        if (latitude > 66.4 && doy > 79 && doy < 267 || latitude < -66.4 && (doy < 83 || doy > 263)) //previous sunrise/next sunset
        jday = $10779855fb2df467$var$calcJDofNextPrevRiseSet(!rise, rise, JD, latitude, longitude, timezone);
        else jday = $10779855fb2df467$var$calcJDofNextPrevRiseSet(rise, rise, JD, latitude, longitude, timezone);
    }
    return {
        "jday": jday,
        "timelocal": timeLocal,
        "azimuth": azimuth
    };
}
function $10779855fb2df467$var$calcJDofNextPrevRiseSet(next, rise, JD, latitude, longitude, tz) {
    var julianday = JD;
    var increment = next ? 1.0 : -1;
    var time = $10779855fb2df467$var$calcSunriseSetUTC(rise, julianday, latitude, longitude);
    while(!$10779855fb2df467$var$isNumber(time)){
        julianday += increment;
        time = $10779855fb2df467$var$calcSunriseSetUTC(rise, julianday, latitude, longitude);
    }
    var timeLocal = time + tz * 60.0;
    while(timeLocal < 0.0 || timeLocal >= 1440.0){
        var incr = timeLocal < 0 ? 1 : -1;
        timeLocal += incr * 1440.0;
        julianday -= incr;
    }
    return julianday;
}


const $34af489db025f5d1$var$DEFAULT_DELAY = 16;
function $34af489db025f5d1$export$de363e709c412c8a(callback, delay = $34af489db025f5d1$var$DEFAULT_DELAY) {
    let ready = true;
    let callbackArgs;
    let wasInvoked = false;
    function readyCallback() {
        if (wasInvoked) {
            callback.apply(this, callbackArgs);
            callbackArgs = undefined;
            wasInvoked = false;
            setTimeout(readyCallback, delay);
        } else ready = true;
    }
    return function(...args) {
        if (ready) {
            ready = false;
            setTimeout(readyCallback, delay);
            callback.apply(this, args);
        } else {
            callbackArgs = args;
            wasInvoked = true;
        }
    };
}


const $0cbd7f18f9a203df$var$HELP_FADE_DELAY = 3000;
const $0cbd7f18f9a203df$var$MINUTES_PER_DAY = 1440;
const $0cbd7f18f9a203df$var$TWELVE_HOURS_IN_MS = 43200000;
const $0cbd7f18f9a203df$var$config = new Proxy(JSON.parse(localStorage.getItem('chilloclock') || '{}'), {
    get (target, property) {
        return target[property];
    },
    set (target, property, value) {
        target[property] = value;
        requestAnimationFrame(function() {
            localStorage.setItem('chilloclock', JSON.stringify(target));
        });
        return true;
    }
});
const $0cbd7f18f9a203df$var$helpIconNode = document.getElementById('helpIcon');
const $0cbd7f18f9a203df$var$welcomeNode = document.getElementById('welcome');
const $0cbd7f18f9a203df$var$closeIcon = $0cbd7f18f9a203df$var$welcomeNode.querySelector('.closeIcon');
const $0cbd7f18f9a203df$var$clockNode = document.querySelector('.chilloclock');
const $0cbd7f18f9a203df$var$fadeOverlayNode = document.querySelector('.fadeOverlay');
if ($0cbd7f18f9a203df$var$config.baseSize) $0cbd7f18f9a203df$var$clockNode.style.setProperty('--base-size', `${$0cbd7f18f9a203df$var$config.baseSize}px`);
let $0cbd7f18f9a203df$var$isNight = false;
let $0cbd7f18f9a203df$var$sunrise;
let $0cbd7f18f9a203df$var$sunset;
let $0cbd7f18f9a203df$var$updateHandle = 0;
// during the day this will be sunrise.timelocal
// during the night sunset.timelocal
let $0cbd7f18f9a203df$var$timePeriodBegin;
// during the day this will be sunset.timelocal - sunrise.timelocal
// during the night this will be nextDaySunrise.timelocal - sunset.timelocal
let $0cbd7f18f9a203df$var$timePeriodDuration;
// 10 seconds - the angle only actually changes about once every minute
const $0cbd7f18f9a203df$var$updateFrequency = 10000;
function $0cbd7f18f9a203df$var$update() {
    clearTimeout($0cbd7f18f9a203df$var$updateHandle);
    const now = new Date();
    const timeInMinutes = now.getHours() * 60 + now.getMinutes();
    const isAfterMidnight = timeInMinutes < $0cbd7f18f9a203df$var$timePeriodBegin;
    const percentOfTimePeriodElapsed = isAfterMidnight ? (timeInMinutes + $0cbd7f18f9a203df$var$MINUTES_PER_DAY - $0cbd7f18f9a203df$var$sunset.timelocal) / $0cbd7f18f9a203df$var$timePeriodDuration : (timeInMinutes - $0cbd7f18f9a203df$var$timePeriodBegin) / $0cbd7f18f9a203df$var$timePeriodDuration;
    if (percentOfTimePeriodElapsed > 1) {
        $0cbd7f18f9a203df$var$initClock($0cbd7f18f9a203df$var$config.geolocation.latitude, $0cbd7f18f9a203df$var$config.geolocation.longitude);
        return;
    }
    // narrow interpretation of twilight as 10 minutes preceding sunset/sunrise
    const isTwilight = isAfterMidnight ? $0cbd7f18f9a203df$var$sunrise.timelocal - timeInMinutes < 10 : $0cbd7f18f9a203df$var$sunset.timelocal - timeInMinutes < 10;
    if (isTwilight) {
        if (isAfterMidnight) {
            if (!$0cbd7f18f9a203df$var$fadeOverlayNode.classList.contains('morningFade')) $0cbd7f18f9a203df$var$fadeOverlayNode.classList.add('morningFade');
            else if (!$0cbd7f18f9a203df$var$fadeOverlayNode.classList.contains('nightFade')) $0cbd7f18f9a203df$var$fadeOverlayNode.classList.add('nightFade');
        }
    }
    const armAngle = 180 * percentOfTimePeriodElapsed + ($0cbd7f18f9a203df$var$isNight ? 0 : 180);
    $0cbd7f18f9a203df$var$clockNode.style.setProperty('--arm-angle', `${armAngle}deg`);
    $0cbd7f18f9a203df$var$updateHandle = setTimeout($0cbd7f18f9a203df$var$update, $0cbd7f18f9a203df$var$updateFrequency);
}
$0cbd7f18f9a203df$var$helpIconNode.addEventListener('animationend', function(event) {
    if (event.target.classList.contains('fadeout')) {
        event.target.classList.remove('fadeout');
        event.target.hidden = true;
    } else event.target.classList.remove('fadein');
});
let $0cbd7f18f9a203df$var$helpFadeHandle = 0;
function $0cbd7f18f9a203df$var$fadeoutHelp() {
    $0cbd7f18f9a203df$var$helpIconNode.classList.add('fadeout');
}
function $0cbd7f18f9a203df$var$showHelpIcon() {
    clearTimeout($0cbd7f18f9a203df$var$helpFadeHandle);
    $0cbd7f18f9a203df$var$helpIconNode.classList.remove('fadeout');
    if ($0cbd7f18f9a203df$var$helpIconNode.hidden) {
        $0cbd7f18f9a203df$var$helpIconNode.classList.add('fadein');
        $0cbd7f18f9a203df$var$helpIconNode.hidden = false;
    }
    $0cbd7f18f9a203df$var$helpFadeHandle = setTimeout($0cbd7f18f9a203df$var$fadeoutHelp, $0cbd7f18f9a203df$var$HELP_FADE_DELAY);
}
function $0cbd7f18f9a203df$var$hideWelcome() {
    $0cbd7f18f9a203df$var$welcomeNode.hidden = true;
}
function $0cbd7f18f9a203df$var$onKeydown(event) {
    if (event.key === 'Escape') $0cbd7f18f9a203df$var$hideWelcome();
}
document.addEventListener('keydown', $0cbd7f18f9a203df$var$onKeydown);
document.body.addEventListener('pointermove', (0, $34af489db025f5d1$export$de363e709c412c8a)($0cbd7f18f9a203df$var$showHelpIcon, 500));
$0cbd7f18f9a203df$var$closeIcon.addEventListener('click', $0cbd7f18f9a203df$var$hideWelcome);
function $0cbd7f18f9a203df$var$initClock(latitude, longitude) {
    $0cbd7f18f9a203df$var$config.geolocation = {
        latitude: latitude,
        longitude: longitude
    };
    const now = new Date();
    const timezoneOffset = -(now.getTimezoneOffset() / 60);
    const jday = (0, $10779855fb2df467$export$fb750f7620defd41)(now.getFullYear(), now.getMonth() + 1, now.getDate());
    $0cbd7f18f9a203df$var$sunrise = (0, $10779855fb2df467$export$a312825e91363456)(1, jday, latitude, longitude, timezoneOffset);
    $0cbd7f18f9a203df$var$sunset = (0, $10779855fb2df467$export$a312825e91363456)(0, jday, latitude, longitude, timezoneOffset);
    const timeInMinutes = now.getHours() * 60 + now.getMinutes();
    // early morning of previous night
    if (timeInMinutes < $0cbd7f18f9a203df$var$sunrise.timelocal) {
        $0cbd7f18f9a203df$var$isNight = true;
        const previousDay = new Date(now.getTime() - $0cbd7f18f9a203df$var$TWELVE_HOURS_IN_MS);
        const previousJday = (0, $10779855fb2df467$export$fb750f7620defd41)(previousDay.getFullYear(), previousDay.getMonth() + 1, previousDay.getDate());
        const previousSunset = (0, $10779855fb2df467$export$a312825e91363456)(0, previousJday, latitude, longitude, timezoneOffset);
        $0cbd7f18f9a203df$var$timePeriodBegin = previousSunset.timelocal;
        $0cbd7f18f9a203df$var$timePeriodDuration = $0cbd7f18f9a203df$var$sunrise.timelocal + $0cbd7f18f9a203df$var$MINUTES_PER_DAY - $0cbd7f18f9a203df$var$timePeriodBegin;
    } else if (timeInMinutes < $0cbd7f18f9a203df$var$sunset.timelocal) {
        $0cbd7f18f9a203df$var$isNight = false;
        $0cbd7f18f9a203df$var$timePeriodBegin = $0cbd7f18f9a203df$var$sunrise.timelocal;
        $0cbd7f18f9a203df$var$timePeriodDuration = $0cbd7f18f9a203df$var$sunset.timelocal - $0cbd7f18f9a203df$var$sunrise.timelocal;
    } else {
        $0cbd7f18f9a203df$var$isNight = true;
        $0cbd7f18f9a203df$var$timePeriodBegin = $0cbd7f18f9a203df$var$sunset.timelocal;
        const nextDay = new Date(now.getTime() + $0cbd7f18f9a203df$var$TWELVE_HOURS_IN_MS);
        const nextJday = (0, $10779855fb2df467$export$fb750f7620defd41)(nextDay.getFullYear(), nextDay.getMonth() + 1, nextDay.getDate());
        $0cbd7f18f9a203df$var$sunrise = (0, $10779855fb2df467$export$a312825e91363456)(1, nextJday, latitude, longitude, timezoneOffset);
        $0cbd7f18f9a203df$var$timePeriodDuration = $0cbd7f18f9a203df$var$sunrise.timelocal + $0cbd7f18f9a203df$var$MINUTES_PER_DAY - $0cbd7f18f9a203df$var$timePeriodBegin;
    }
    if ($0cbd7f18f9a203df$var$isNight) document.body.classList.add('night');
    else document.body.classList.remove('night');
    $0cbd7f18f9a203df$var$hideWelcome();
    $0cbd7f18f9a203df$var$helpFadeHandle = setTimeout($0cbd7f18f9a203df$var$fadeoutHelp, $0cbd7f18f9a203df$var$HELP_FADE_DELAY);
    $0cbd7f18f9a203df$var$update();
}
const $0cbd7f18f9a203df$var$hasGeolocation = 'geolocation' in navigator;
function $0cbd7f18f9a203df$var$showLocationForm() {
    const wikiButton = document.getElementById('wikiButton');
    wikiButton.addEventListener('click', function() {
        const cityInput = document.getElementById('city');
        if (cityInput.value) window.open(`https://en.wikipedia.org/w/index.php?title=Special%3ASearch&search=${cityInput.value}`, '_blank');
    });
    const coordinatesForm = document.getElementById('coordinatesForm');
    coordinatesForm.addEventListener('submit', function(event) {
        event.preventDefault();
        const { latitude: latitude, longitude: longitude } = coordinatesForm.elements;
        $0cbd7f18f9a203df$var$initClock(Number(latitude.value), Number(longitude.value));
    });
    const locationForm = document.getElementById('locationForm');
    locationForm.hidden = false;
}
function $0cbd7f18f9a203df$var$showWelcomeDialog() {
    const locationButton = document.getElementById('locationButton');
    if ($0cbd7f18f9a203df$var$hasGeolocation) locationButton.addEventListener('click', function() {
        navigator.geolocation.getCurrentPosition(function(position) {
            $0cbd7f18f9a203df$var$initClock(position.coords.latitude, position.coords.longitude);
        }, $0cbd7f18f9a203df$var$showLocationForm);
    });
    else {
        locationButton.hidden = true;
        $0cbd7f18f9a203df$var$showLocationForm();
    }
    $0cbd7f18f9a203df$var$welcomeNode.hidden = false;
}
let { geolocation: $0cbd7f18f9a203df$var$geolocation } = $0cbd7f18f9a203df$var$config;
if ($0cbd7f18f9a203df$var$geolocation) $0cbd7f18f9a203df$var$initClock($0cbd7f18f9a203df$var$geolocation.latitude, $0cbd7f18f9a203df$var$geolocation.longitude);
else $0cbd7f18f9a203df$var$showWelcomeDialog();
$0cbd7f18f9a203df$var$helpIconNode.addEventListener('click', $0cbd7f18f9a203df$var$showWelcomeDialog);
$0cbd7f18f9a203df$var$fadeOverlayNode.addEventListener('animationend', function(event) {
    if (event.animationName === 'nightFade') {
        event.target.classList.remove('nightFade');
        event.target.classList.add('night');
    } else {
        event.target.classList.remove('morningFade');
        event.target.classList.remove('night');
    }
});
document.addEventListener('keydown', function(event) {
    let baseSize = $0cbd7f18f9a203df$var$config.baseSize || parseInt(getComputedStyle($0cbd7f18f9a203df$var$clockNode).getPropertyValue('--base-size'), 10);
    if (event.key === '=' || event.key === '+') {
        baseSize += 1;
        $0cbd7f18f9a203df$var$clockNode.style.setProperty('--base-size', `${baseSize}px`);
        $0cbd7f18f9a203df$var$config.baseSize = baseSize;
    } else if (event.key === '-') {
        baseSize -= 1;
        $0cbd7f18f9a203df$var$clockNode.style.setProperty('--base-size', `${baseSize}px`);
        $0cbd7f18f9a203df$var$config.baseSize = baseSize;
    }
});


//# sourceMappingURL=chilloclock.9320c17c.js.map
